import * as React from "react";
import { useOptions } from "../../../../hooks/useOptions";
import { TSetUrlParamsArgs } from "../../../../hooks/useXoraia";

import ColorPicker from "./ColorPicker";
import CheckboxFilter from "./CheckboxFilter";
import FilterSection from "./FilterSection";

const OtherOptionsFilter: React.FC<{
  onChange: (args: TSetUrlParamsArgs) => Promise<void>;

  urlParams?: TSetUrlParamsArgs;
}> = (props) => {
  const { options } = useOptions();

  return (
    <React.Fragment>
      {options.map((opt) => {
        if (opt.type === "COLOR") {
          return (
            <FilterSection
              key={opt.name}
              title={opt.name}
              child={
                <ColorPicker
                  {...props}
                  slug={opt.id}
                  colorPickerColors={opt.values}
                />
              }
            />
          );
        }

        return (
          <FilterSection
            key={opt.name}
            title={opt.name}
            child={
              <CheckboxFilter {...props} slug={opt.id} values={opt.values} />
            }
          />
        );
      })}
    </React.Fragment>
  );
};

export default OtherOptionsFilter;
